module.exports = __webpack_public_path__ + "promote-sp-white.svg?78c2a1c308011a74daf497b04f128927";